<template>
  <Transition
    enter-active-class="enter-active"
    leave-active-class="leave-active"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave">
    <div v-if="open">
      <slot></slot>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    open: Boolean,
  },
  methods: {
    beforeEnter(element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = '0px'
        }
        element.style.display = null
      })
    },
    enter(element) {
      requestAnimationFrame(() => {
        setImmediate(() => {
          element.style.height = `${element.scrollHeight}px`
        })
      })
    },
    afterEnter(element) {
      element.style.height = null
    },
    beforeLeave(element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = `${element.offsetHeight}px`
        }
      })
    },
    leave(element) {
      requestAnimationFrame(() => {
        setImmediate(() => {
          element.style.height = '0px'
        })
      })
    },
    afterLeave(element) {
      element.style.height = null
    },
  }
}
</script>

<style>
.enter-active,
.leave-active {
  overflow: hidden;
  transition: height 0.5s;
}
</style>
